/* eslint-disable indent */
import axios from 'axios';
import { c24UserServiceUrl } from '../constants/url-constants';

const DEBUG = process.env.NODE_ENV === 'development2';
let BASE_API_URL = c24UserServiceUrl();
/* Create axios instance */
const api = axios.create({
    baseURL: BASE_API_URL,
    headers: {
        'Content-Type': 'application/json',
        X_VEHICLE_TYPE: 'CAR',
        X_COUNTRY: 'AE',
        X_LANGUAGE: 'EN'
    },
});

api.interceptors.request.use((config) => {
    if (DEBUG) { console.info('✉️ ', config); }
    return config;
}, (error) => {
    if (DEBUG) { console.error('✉️ ', error); }
    return Promise.reject(error);
});

api.interceptors.response.use((response) => {
    if (DEBUG) { console.info('📩 ', response); }
    return response;
}, (error) => {
    if (error.response && error.response.data) {
        if (DEBUG) { console.error('Error: ', error.response.data); }
        return Promise.reject(error.response.data);
    }
    if (DEBUG) { console.error('📩 ', error); }
    return Promise.reject(error.message);
});

export default api;
